import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadioCheckedPurple = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3.75,
			y: 3.75,
			width: 16.5,
			height: 16.5,
			rx: 8.25,
			stroke: "url(#paint0_linear_22_10023)",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 6,
			fill: "url(#paint1_linear_22_10023)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_22_10023",
			x1: 12,
			y1: 3,
			x2: 12,
			y2: 21,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#CF73ED" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#8C0DB6"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_22_10023",
			x1: 12,
			y1: 6,
			x2: 12,
			y2: 18,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#CF73ED" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#8C0DB6"
			})]
		})] })
	]
});
export default SvgRadioCheckedPurple;
